// extracted by mini-css-extract-plugin
export default {"container":"BlockTransition_container__rQx4W","blockContainer":"BlockTransition_blockContainer__rArsj","block":"BlockTransition_block__97efJ"};